const capabilities = {
    app: ['loader', 'paginator', 'filter', 'sorter', 'exporter', 'error-logger'],
    entity: ['safe-deleter', 'locker', 'archiver', 'workflow']
};

export default capabilities;
